import React, { useState } from 'react'
import { ChevronDown, ChevronUp, Filter } from '../../atoms/NewIcons'
import Chip from '../../atoms/Chip/Chip'
import useTrans from '../../../hooks/useTrans'

const CategorieListingMobile = ({ placeholder = '', children, openFilters }) => {
  const t = useTrans()
  const [openMenu, setOpenMenu] = useState(false)
  return (
    <div className={`categorie-mobile`}>
      <div className={`categorie-mobile__content`}>
        <div className="categorie-mobile__nav-trigger" onClick={() => setOpenMenu(!openMenu)}>
          {placeholder || t('Categorie')}
          {openMenu ? (
            <ChevronUp classes="categorie-mobile__arrow-icon" />
          ) : (
            <ChevronDown classes="categorie-mobile__arrow-icon" />
          )}
        </div>
        <Chip
          placeholder={t('Filtri')}
          size="md"
          icon={<Filter />}
          iconPos="left"
          onClick={openFilters}
        />
      </div>
      <div
        className={
          'categorie-mobile__children' + (openMenu ? ' categorie-mobile__children--open' : '')
        }
      >
        {children}
      </div>
    </div>
  )
}

export default CategorieListingMobile
